import { Lightning as lng, Registry, Utils } from '@lightningjs/sdk';
import { Theme } from '../../config/theme';
import { ZappingBarCard } from './ZappingBarCard';

export const _constants = {
  zappingBarWidth: 400,
  backgroundHeight: 150,
  channelCardHeight: 146,
  channelCardBottomMargin: 8,
  channelCardCornerRadius: [0, 20, 20, 0],
  delay: 50,
  verticalPaddingFavorite: 25,
  verticalPadding: 20,
  leftPadding: 120,
  rightPadding: 20,
  maxTextWidth: 180,
  maxImageWidth: 180,
  selectorIconWidth: 30,
  selectorIconHeight: 60,
  autoSelectTimeout: 1000,
};

export class ZappingBar extends lng.Component {
  static _template() {
    return {
      w: w => w,
      h: h => h,
      LeftBackground: {
        h: h => h,
        w: _constants.zappingBarWidth,
        rect: true,
        colorLeft: Theme.Colors.CmsZappingBar.CardBackground,
        colorRight: Theme.Colors.Transparent,
      },
      ChannelCardsContainer: {
        x: -_constants.zappingBarWidth,
        h: h => h,
        w: _constants.zappingBarWidth,
      },
      SelectorIcon: {
        y: h => h / 2,
        mountY: 0.5,
        w: _constants.selectorIconWidth,
        h: _constants.selectorIconHeight,
        src: Utils.asset('images/zappingBar/selector.png'),
        color: Theme.Colors.Primary,
      },
      TopBackground: {
        x: 0,
        // y: 0,
        y: -_constants.backgroundHeight,
        h: _constants.backgroundHeight,
        w: w => w,
        rect: true,
        colorTop: Theme.Colors.CmsZappingBar.Background,
        colorBottom: Theme.Colors.Transparent,
      },
      BottomBackground: {
        x: 0,
        mountY: 1,
        // y: h => h,
        y: 1080 + _constants.backgroundHeight,
        h: _constants.backgroundHeight,
        w: w => w,
        rect: true,
        colorTop: Theme.Colors.Transparent,
        colorBottom: Theme.Colors.CmsZappingBar.Background,
      },
    };
  }

  _init() {
    this._cardsContainer = this.tag('ChannelCardsContainer');
    this.prevTime = 0;
    this._params = undefined;
  }

  _focus() {
    this.tag('ChannelCardsContainer').setSmooth('x', 0);
    this.tag('SelectorIcon').setSmooth('x', 0);
    this.tag('TopBackground').setSmooth('y', 0);
    this.tag('BottomBackground').setSmooth('y', 1080);
  }

  _unfocus() {
    this.tag('ChannelCardsContainer').setSmooth('x', -_constants.zappingBarWidth);
    this.tag('SelectorIcon').setSmooth('x', -_constants.zappingBarWidth);
    this.tag('TopBackground').setSmooth('y', -_constants.backgroundHeight);
    this.tag('BottomBackground').setSmooth('y', 1080 + _constants.backgroundHeight);
  }

  _handleDown() {
    this.switchingChUpChDown = false;
    if (this.channelActivationTimeout) Registry.clearTimeout(this.channelActivationTimeout);
    let now = new Date().getTime();
    if (now - this.prevTime > _constants.delay) {
      this.prevTime = now;
      this.shiftItemUp();
      this.updateUIAnimated();
    }
    return false;
  }

  _handleUp() {
    this.switchingChUpChDown = false;
    if (this.channelActivationTimeout) Registry.clearTimeout(this.channelActivationTimeout);
    let now = new Date().getTime();
    if (now - this.prevTime > _constants.delay) {
      this.prevTime = now;
      this.shiftItemDown();
      this.updateUIAnimated();
    }
    return false;
  }

  _getFocused() {
    return this._cardsContainer.children[5];
  }

  _active() {
    let currentChannelId = this._backend.playerController.streamManager._currentStreamInfo._epgEvent.channel.channelId;

    // select current channel
    for (let i = 0; i < this._cardsContainer.childList.length; i++) {
      if (this._cardsContainer.children[5].channelID === currentChannelId) {
        break;
      } else {
        this.shiftItemUp();
      }
    }
    this.updateUI();
    if (this._params?.channelUp) {
      this._handleDown();
      this.switchingChUpChDown = true;
      this.updateAutoSelect();
    }
    if (this._params?.channelDown) {
      this._handleUp();
      this.switchingChUpChDown = true;
      this.updateAutoSelect();
    }
  }

  _handleChannelUp() {
    this._handleDown();
    this.switchingChUpChDown = true;
    // reset timeout
    this.updateAutoSelect();
    return true;
  }

  _handleChannelDown() {
    this._handleUp();
    this.switchingChUpChDown = true;
    // reset timeout
    this.updateAutoSelect();
    return true;
  }

  _handleEnter() {
    // activate changeStream function in PlayerPage
    if (!this.switchingChUpChDown) {
      this.fireAncestors('$changeStream', this._cardsContainer.children[5].channelModel);
    } else {
      this._owner._overlayHelper.onStart();
    }
  }

  updateAutoSelect() {
    this._owner._overlayHelper._startShowTimer();
    if (this.channelActivationTimeout) Registry.clearTimeout(this.channelActivationTimeout);
    this.channelActivationTimeout = Registry.setTimeout(() => {
      // activate changeStream function in PlayerPage
      this.fireAncestors('$changeStream', this._cardsContainer.children[5].channelModel, false);
    }, _constants.autoSelectTimeout);
  }

  shiftItemUp() {
    let card = this._cardsContainer.childList.first;
    this._cardsContainer.childList.remove(card);
    this._cardsContainer.childList.add(card);
  }

  shiftItemDown() {
    let card = this._cardsContainer.childList.last;
    this._cardsContainer.childList.remove(card);
    this._cardsContainer.childList.addAt(card, 0);
  }

  updateUI() {
    this._cardsContainer.childList.forEach((card, i) => {
      card.patch({ y: (_constants.channelCardHeight + _constants.channelCardBottomMargin) * (i - 2) });
    });
  }

  updateUIAnimated() {
    this._cardsContainer.childList.forEach((card, i) => {
      if (i === 0) {
        card.patch({ y: (_constants.channelCardHeight + _constants.channelCardBottomMargin) * (i - 2) });
      }
      if (i < 10) {
        card.setSmooth('y', (_constants.channelCardHeight + _constants.channelCardBottomMargin) * (i - 2));
      } else {
        card.patch({ y: (_constants.channelCardHeight + _constants.channelCardBottomMargin) * (i - 2) });
      }
    });
  }

  set catalogID(id) {
    this._catalogID = id;
  }

  set channels(channelArray) {
    // get channel numbers from catalog
    channelArray.forEach(channel => {
      const catalog = channel.catalogs.find(cat => cat.catalogId === this._catalogID);
      channel.channelNumber = catalog ? catalog.channelNumber : 999;
    });

    // sort by channel number
    const compare = (a, b) => {
      if (a.channelNumber < b.channelNumber) {
        return -1;
      }
      if (a.channelNumber > b.channelNumber) {
        return 1;
      }
      return 0;
    };
    channelArray.sort(compare);

    // sort by favourites and add to UI
    let cachedFavApi = this._backend.cachedFavoriteApi;
    const channelIdList = channelArray.map(channel => ({
      type: 'CHANNEL',
      id: channel.channelId,
    }));

    cachedFavApi.isFavoriteMap(this._backend, channelIdList).then(favoriteMap => {
      channelArray.forEach(channel => {
        channel.isFavorite = favoriteMap.get(channel.channelId);
      });
      const favs = channelArray.filter(el => el.isFavorite);
      const notFavs = channelArray.filter(el => !el.isFavorite);
      const finalChannelArray = favs.concat(notFavs);

      finalChannelArray.forEach((channel, i) => {
        this._cardsContainer.childList.a({
          type: ZappingBarCard,
          y: (_constants.channelCardHeight + _constants.channelCardBottomMargin) * (i - 2),
          channelModel: channel,
          backend: this._backend,
          favorite: favoriteMap.get(channel.channelId),
        });
      });
      this.checkEnoughItems();
    });
  }

  checkEnoughItems() {
    // add the same items if there are less than 10
    while (this._cardsContainer.childList.length < 10) {
      this._cardsContainer.children.forEach(item => {
        this._cardsContainer.childList.a({
          type: ZappingBarCard,
          y: 0,
          channelModel: item.channelModel,
          backend: this._backend,
          favorite: item.isFavorite,
        });
      });
    }
  }

  set backend(back) {
    this._backend = back;
  }

  set params(params) {
    this._params = params;
  }

  set componentOwner(owner) {
    this._owner = owner;
  }
}
